import React, { useContext, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { useConfig } from '@namespace/cms';
import { useIsMounted } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { useUserSegmentsIncludes } from '@namespace/segments';
import { UserContext } from '@namespace/user/src/context';
import Snippet from '../Snippet';
import { SegmentedSnippetProps, Slide } from './types';

import styles from './index.module.css';

const SegmentedSnippet: React.FC<SegmentedSnippetProps> = ({
  id,
  config: externalConfig
}) => {
  const { t } = useI18n();
  const { config } = useConfig(id);
  const { slides } = isEmpty(config) ? externalConfig : config; // used for customFooter in 3column layout
  const isUserSegmentsIncludes = useUserSegmentsIncludes();
  const [user] = useContext(UserContext);
  const { userInfoLoaded } = user;

  const currentSlide = useMemo((): Slide | null => {
    const filteredSlides = slides?.filter((slide: Slide) =>
      isUserSegmentsIncludes(slide.userSegments)
    );
    const [slide] = filteredSlides;

    return slide || null;
  }, [slides, isUserSegmentsIncludes]);

  const isMounted = useIsMounted();
  const slidesHaveUserSegments = slides?.some(
    (slide: Slide) => slide.userSegments?.length
  );

  const snippetId = currentSlide?.snippetId || null;
  const title = currentSlide?.title || '';

  if (
    !snippetId ||
    (window.IS_SSR && slidesHaveUserSegments && (!isMounted || !userInfoLoaded))
  ) {
    return null;
  }

  if (title) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.page}>
          <div className={styles.header}>{t(title)}</div>
          <div className={styles.content}>
            <Snippet snippetId={snippetId} />
          </div>
        </div>
      </div>
    );
  }

  return <Snippet snippetId={snippetId} />;
};

export default SegmentedSnippet;
